import { ShoppingCart } from '../models/shopping-cart.model';
import { ShoppingCartActions, ShoppingCartActionTypes } from '../actions/shoppingcart.actions';
import { createSelector } from '@ngrx/store';
import { AppState } from './index';
import { CartDetailViewModel } from '../models/cart-item.model';

export interface ShoppingCartState {
    loadError: string;
    createError: string;
    loaded: boolean;
    creatingShoppingCart: boolean;
    shoppingCarts: ShoppingCart[];
    shoppingCartView: {
        isLoading: boolean,
        cartId: string,
        items: CartDetailViewModel[]
    };
}

export const initialState: ShoppingCartState = {
    loadError: null,
    createError: null,
    loaded: false,
    shoppingCarts: [],
    creatingShoppingCart: false,
    shoppingCartView: {
        isLoading: false,
        cartId: null,
        items: null
    }
};

export function ShoppingCartReducer(state = initialState,
    action: ShoppingCartActions) {
    switch (action.type) {

        case ShoppingCartActionTypes.LoadShoppingCart:
            return {
                ...state,
                loaded: false
            };
        case ShoppingCartActionTypes.LoadShoppingCartSuccess:
            {
                let selectedCartId = null;

                let selectedCart = null;

                if (state.shoppingCarts.length > 0) {

                    selectedCart = state.shoppingCarts.find(cart => cart.isSelected);

                    if (selectedCart) {
                        selectedCartId = selectedCart.cartId;
                    }
                }

                if (action.payload.length > 0) {

                    action.payload = action.payload.map((val, index) => {

                        if (selectedCartId) {

                            if (val.cartId === selectedCartId) {
                                val.isSelected = true;
                                return val;
                            } else {
                                val.isSelected = false;
                                return val;
                            }

                        } else {
                            if (index === 0) {
                                val.isSelected = true;
                                return val;
                            } else {
                                val.isSelected = false;
                                return val;
                            }
                        }
                    });

                }
                return {
                    ...state,
                    loaded: true,
                    shoppingCarts: action.payload,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: null,
                        items: null
                    }
                };
            }

        case ShoppingCartActionTypes.LoadShoppingCartFailure:
            return {
                ...state,
                loadError: action.payload
            };

        case ShoppingCartActionTypes.CreateShoppingCart:
            {
                return {
                    ...state,
                    creatingShoppingCart: true
                };
            }

        case ShoppingCartActionTypes.CreateShoppingCartSuccess:
            {
                const carts = state.shoppingCarts.map(cart => {
                    if (cart.isSelected) {
                        cart.isSelected = false;
                    }
                    return cart;
                });

                return {
                    ...state,
                    shoppingCarts: carts.concat(action.payload),
                    creatingShoppingCart: false
                };
            }

        case ShoppingCartActionTypes.CreateShoppingCartFailure:
            return {
                ...state,
                createError: action.payload,
                creatingShoppingCart: false
            };

        case ShoppingCartActionTypes.DeleteShoppingCart:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.DeleteShoppingCartSuccess:
            {
                // const carts = state.shoppingCarts.filter((val, index) => {
                //     return val.cartId !== action.payload;
                // })

                // carts[0].isSelected = true;

                let carts = state.shoppingCarts.map((val, index) => {

                    if (val.cartId === action.payload) {
                        if (index < (state.shoppingCarts.length - 1)) {
                            state.shoppingCarts[index + 1].isSelected = true;
                        } else {
                            state.shoppingCarts[0].isSelected = true;
                        }
                    }

                    return val;
                })


                carts = carts.filter((val, index) => {
                    return val.cartId !== action.payload;
                });

                const newCartView = { ...state.shoppingCartView };

                if (parseInt(state.shoppingCartView.cartId) === action.payload) {
                    newCartView.cartId = null;
                    newCartView.items = null;
                }

                return {
                    ...state,
                    shoppingCarts: carts,
                    shoppingCartView: newCartView
                };
            }

        case ShoppingCartActionTypes.DeleteShoppingCartFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.UpdateShoppingCart: {
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        }

        case ShoppingCartActionTypes.UpdateShoppingCartSuccess:
            {
                const newShoppintCarts = state.shoppingCarts.map((cart) => {

                    if (cart.cartId === action.payload.cartId) {
                        cart.cartName = action.payload.cartName;
                    }

                    return cart;
                });

                return {
                    ...state,
                    shoppingCarts: newShoppintCarts,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };

            }

        case ShoppingCartActionTypes.UpdateShoppingCartFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.CloneShoppintCart:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.CloneShoppintCartSuccess:
            {
                const carts = state.shoppingCarts.map(cart => {
                    if (cart.isSelected) {
                        cart.isSelected = false;
                    }
                    return cart;
                });

                return {
                    ...state,
                    shoppingCarts: carts.concat(action.payload)
                };
            }


        case ShoppingCartActionTypes.CloneShoppintCartFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.SelectShoppingCartNoRedirectSuccess:
            {
                const sortedCarts = state.shoppingCarts.map(cart => {
                    if (cart.cartId === action.payload) {
                        cart.isSelected = true;
                        return cart;
                    } else {
                        cart.isSelected = false;
                        return cart;
                    }
                });
                return {
                    ...state,
                    shoppingCarts: sortedCarts
                };
            }

        case ShoppingCartActionTypes.SelectShoppingCartNoRedirectFailure:
            return {
                ...state
            };
        case ShoppingCartActionTypes.SelectShoppingCartSuccess:
            {
                const _sortedCarts = state.shoppingCarts.map(cart => {
                    if (cart.cartId === action.payload.cartId) {
                        cart.isSelected = true;
                        return cart;
                    } else {
                        cart.isSelected = false;
                        return cart;
                    }
                });
                return {
                    ...state,
                    shoppingCarts: _sortedCarts
                };
            }

        case ShoppingCartActionTypes.SelectShoppingCartFailure:
            return {
                ...state
            };
        case ShoppingCartActionTypes.LoadShoppingCartItem:
            {

                return {
                    ...state,
                    shoppingCartView: {
                        isLoading: true,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }

        case ShoppingCartActionTypes.LoadShoppingCartItemSuccess:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: action.payload.cartId.toString(),
                    items: action.payload.items
                }
            };

        case ShoppingCartActionTypes.LoadShoppingCartItemFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        case ShoppingCartActionTypes.UpdateShoppingCartItemQty: {
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        }

        case ShoppingCartActionTypes.UpdateShoppingCartItemQtySuccess:
            {
                const updatedItems = state.shoppingCartView.items.map(item => {
                    if (item.stockCode === action.payload.stockCode && item.cartItemID === action.payload.cartItemID) {
                        item = action.payload;
                        return item;
                    } else {
                        return item;
                    }
                });

                let updatedTotalPrice = 0;
                let updatedItemsQty = 0;
                updatedItems.forEach(item => {
                    updatedTotalPrice += item.subTotal;
                    updatedItemsQty += item.quantity;
                });



                const updatedShoppingCarts = state.shoppingCarts.map((cart) => {
                    if (cart.cartId === action.payload.cartID) {
                        cart.totalQuantity = updatedItemsQty;
                        cart.totalPrice = updatedTotalPrice;
                        return cart;

                    } else {
                        return cart;
                    }
                });
                return {
                    ...state,
                    shoppingCarts: updatedShoppingCarts,
                    shoppingCartView: {
                        isLoading: false,
                        items: updatedItems,
                        cartId: state.shoppingCartView.cartId
                    }
                };
            }

        case ShoppingCartActionTypes.UpdateShoppingCartItemQtyFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };

        case ShoppingCartActionTypes.DeleteShoppingCartItem:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        case ShoppingCartActionTypes.DeleteShoppingCartItemSuccess:
            {
                const updatedItems = state.shoppingCartView.items.filter((item:any) => {
                    if (item.cartItemID !== action.payload.cartItemID) {
                        return item;
                    }
                });

                let updatedTotalPrice = 0;
                let updatedItemsQty = 0;
                updatedItems.forEach(item => {
                    updatedTotalPrice += item.subTotal;
                    updatedItemsQty += item.quantity;
                });

                const updatedShoppingCarts = state.shoppingCarts.map((cart) => {
                    if (cart.cartId === action.payload.cartID) {
                        let cloneCart = Object.assign({}, cart)
                        cloneCart.totalQuantity = updatedItemsQty;
                        cloneCart.totalPrice = updatedTotalPrice;
                        return cloneCart;

                    } else {
                        return cart;
                    }
                });

                return {
                    ...state,
                    shoppingCarts: updatedShoppingCarts,
                    shoppingCartView: {
                        isLoading: false,
                        items: updatedItems,
                        cartId: state.shoppingCartView.cartId
                    }
                };
            }
        case ShoppingCartActionTypes.DeleteShoppingCartItemFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        case ShoppingCartActionTypes.InsertShoppingCartItem:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: true,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        case ShoppingCartActionTypes.InsertShoppingCartItemSuccess:
            {
                const carts = state.shoppingCarts.map(cart => {
                    if (cart.cartId === action.payload.cartId) {
                        return action.payload;
                    } else {
                        return cart;
                    }
                });
                return {
                    ...state,
                    shoppingCarts: carts,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }

        case ShoppingCartActionTypes.InsertShoppingCartItemFailure:
            return {
                ...state,
                shoppingCartView: {
                    isLoading: false,
                    cartId: state.shoppingCartView.cartId,
                    items: state.shoppingCartView.items
                }
            };
        case ShoppingCartActionTypes.ShareShoppingCart:
            {
                return {
                    ...state,
                    shoppingCartView: {
                        isLoading: true,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }
        case ShoppingCartActionTypes.ShareShoppingCartSuccess:
            {
                const carts = state.shoppingCarts.map(cart => {
                    if (cart.cartId === parseInt(action.payload.cartId)) {
                        cart.status = action.payload.status;
                        return cart;
                    } else {
                        return cart;
                    }
                });
                return {
                    ...state,
                    shoppingCarts: carts,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }
        case ShoppingCartActionTypes.ShareShoppingCartFailure:
            {
                return {
                    ...state,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }
        case ShoppingCartActionTypes.CheckoutShoppingCart:
            {
                return {
                    ...state,
                    shoppingCartView: {
                        isLoading: true,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }
        case ShoppingCartActionTypes.CheckoutShoppingCartSuccess:
            {
                const carts = state.shoppingCarts.filter((val, index) => {
                    return val.cartId !== action.payload;
                });
                if (carts.length) {
                    carts[0].isSelected = true;
                }

                const newCartView = { ...state.shoppingCartView };

                if (parseInt(state.shoppingCartView.cartId) === action.payload) {
                    newCartView.cartId = null;
                    newCartView.items = null;
                }
                return {
                    ...state,
                    shoppingCarts: carts,
                    shoppingCartView: newCartView
                };
            }
        case ShoppingCartActionTypes.CheckoutShoppingCartFailure:
            {
                return {
                    ...state,
                    shoppingCartView: {
                        isLoading: false,
                        cartId: state.shoppingCartView.cartId,
                        items: state.shoppingCartView.items
                    }
                };
            }
        default:
            return {
                ...state
            };
    }

}


// selector
export const selectShoppingCartFeature = (state: AppState) => state.shoppingCartState;

export const getShoppingCartLoaded = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.loaded);

export const getShoppingCarts = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.shoppingCarts
);

export const getSelectedShoppingCart = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.shoppingCarts.find(carts => carts.isSelected === true)
);

export const getIsCreatingShoppingCart = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.creatingShoppingCart
);

export const getShoppingCartView = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.shoppingCartView
);

export const getSelectedShoppingCartTotalPrice = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => {
        let totalPrice = 0;
        if (state.shoppingCarts.length) {
            totalPrice = state.shoppingCarts.find(carts => carts.isSelected === true).totalPrice;
        }
        return totalPrice;
    }
);

export const getShoppintCartItemLoading = createSelector(
    selectShoppingCartFeature,
    (state: ShoppingCartState) => state.shoppingCartView.isLoading
);
